/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import WidgetTable from 'components/kea/tables/WidgetTable';
import { linkToProductDetail } from 'util/appUtils';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import AnalyticsMetricBar from 'app/routes/search/analytic/components/AnalyticsMetricBar';
import CardContainerSmall from '../../CardContainerSmall';

const BriefPopularProductsByView = ({
  popularByView,
  currentShop,
}) => {
  const { isFetching, data, error } = popularByView;
  const localizeMessage = useLocalizedMessage();
  const rows = Array.isArray(data) ? data : [];
  const maximumViews = Math.max(1, ...rows.map((row) => Number(row.count || 0)));

  const headCells = [
    { id: '#', numeric: false, label: '#' },
    { id: 'name', numeric: false, label: localizeMessage('analytics.table.productName') },
    {
      id: 'count',
      numeric: true,
      label: localizeMessage('analytics.table.views'),
      render: (value) => (
        <AnalyticsMetricBar
          value={value}
          maximum={maximumViews}
          label={localizeMessage('analytics.table.views')}
          tone="productViews"
        />
      ),
    },
  ];

  const prepareRows = (rows) => {
    if (Array.isArray(rows)) {
      return rows
        .slice(0, 7)
        .map((e) => ({
          ...e,
          name: linkToProductDetail(currentShop, e.name, e.id),
        }));
    }
    return [];
  };

  return (
    <CardContainerSmall
      error={error}
      isFetching={isFetching}
      headerId="search.analytics.popularItemsByView.header"
      showMoreUrl={`/app/${currentShop}/store/analytics/popular-products`}
      tone="productViews"
    >
      <WidgetTable
        hidePagination
        rows={prepareRows(rows)}
        headCells={headCells}
        emptyMessageId="analytics.empty.popularViews"
      />
    </CardContainerSmall>
  );
};

BriefPopularProductsByView.propTypes = {
  popularByView: PropTypes.shape({
    isFetching: PropTypes.bool,
    data: PropTypes.array,
    error: PropTypes.any,
  }).isRequired,
  currentShop: PropTypes.string.isRequired,
};

export default BriefPopularProductsByView;
